import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';
import AboutUs from './Components/About/AboutUs';
import ContactUs from './Components/ContactUs/ContactUs';
import Blog from './Components/Blog/Blog';
import BlogDetails from './Components/Blog/BlogDetails';
import TouristVehicles from './Components/TouristVehicles/TouristVehicles';
import { touristVehiclesData } from './Components/TouristVehicles/touristVehiclesData';
import OutstationTrip from './Components/OutstationTrip/OutstationTrip';
import TourPackages from './Components/TourPackages/TourPackages';
import TourPackageDetails from './Components/TourPackages/TourPackageDetails';
import CabRates from './Components/CabRates/CabRates';
import TransportPage from './Components/CabRates/TransportPage';
import QueryForm from './Components/Home/QueryForm';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/query-form" element={<QueryForm />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route path="/b2b-cab-bus-rental-ratesheet" element={<CabRates />} />
        <Route path="/hyderabad-cab-bus-b2b-ratesheet" element={<TransportPage />} />
        <Route path="/tourist-vehicles/:id" element={<TouristVehicles />} /> 
        <Route path="/outstation/:tripId" element={<OutstationTrip />} />
        <Route path="/tour-packages" element={<TourPackages />} />
         <Route path="/tour-packages/:id" element={<TourPackageDetails   />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
